export enum SortOption {
  ASC = "0",
  DESC = "1"
}
